function resolveApiBaseUrl(): string {
  const runtime = window.__RUNTIME_CONFIG__?.API_BASE_URL?.trim()
  if (runtime) return runtime.replace(/\/$/, '')

  const fromVite = import.meta.env.VITE_API_BASE_URL?.trim()
  if (fromVite) return fromVite.replace(/\/$/, '')

  return 'https://maaliondoor-backend-prod-6573o6ksgq-ew.a.run.app'
}

export const API_CONFIG = {
  baseUrl: resolveApiBaseUrl(),
} as const

export const HTTP_STATUS = {
  badRequest: 400,
  unauthorized: 401,
} as const

export const AUTH_API_PATHS = {
  otpRequest: '/auth/otp/request',
  otpVerify: '/auth/otp/verify',
  register: '/auth/register',
  login: '/auth/login',
  google: '/auth/google',
  refresh: '/auth/refresh',
  logout: '/auth/logout',
  me: '/auth/me',
  mePhoneOtp: '/auth/me/phone/otp',
  mePhoneVerify: '/auth/me/phone/verify',
} as const

export { WISHLIST_API_PATHS } from './wishlist'
export { SEARCH_API_PATHS } from './search'
export { ORDER_API_PATHS } from './orders'
export { ADDRESS_API_PATHS } from './addresses'
export { LOCATION_API_PATHS } from './location'
export { EXPRESS_API_PATHS } from './express'
export { SETTINGS_API_PATHS } from './settings'
export { PAYMENT_API_PATHS } from './payments'

export const INQUIRY_API_PATHS = {
  vendor: '/inquiries/vendor',
  b2b: '/inquiries/b2b',
} as const

export const ACHIEVEMENT_API_PATHS = {
  root: '/achievements',
} as const

export const PRODUCT_STATUS = {
  draft: 'draft',
  active: 'active',
  hidden: 'hidden',
  archived: 'archived',
} as const

export const PRODUCT_KIND = {
  standard: 'standard',
  addon: 'addon',
} as const

export const TAXON_TYPE = {
  category: 'category',
  subcategory: 'subcategory',
  occasion: 'occasion',
  collection: 'collection',
} as const

export const BANNER_PLACEMENT = {
  hero: 'hero',
  homeStrip: 'home_strip',
  category: 'category',
  popup: 'popup',
} as const

export const BLOG_POST_STATUS = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
} as const

export const ACHIEVEMENT_TYPE = {
  recognized: 'recognized',
  partner: 'partner',
} as const

export const OCCASION_TONES = [
  'rose',
  'gold',
  'blush',
  'mint',
  'cream',
  'green',
  'slate',
  'leaf',
] as const

export const PRODUCT_CARD_TONES = ['sage', 'rose', 'mint', 'lilac'] as const

export const PRODUCT_UI = {
  priceNote: 'Inclusive of all taxes',
  prepayNote: '50% prepay',
  expressBadge: '60-Min Delivery',
  expressBadgeShort: '60 min',
  cta: {
    addToCart: 'Add to cart',
    buyNow: 'Buy now',
  },
} as const
